/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuDots3HCircleIcon16Light } from './UiMenuDots3HCircleIcon16Light';
import { UiMenuDots3HCircleIcon16Regular } from './UiMenuDots3HCircleIcon16Regular';
import { UiMenuDots3HCircleIcon16Solid } from './UiMenuDots3HCircleIcon16Solid';
import { UiMenuDots3HCircleIcon20Light } from './UiMenuDots3HCircleIcon20Light';
import { UiMenuDots3HCircleIcon20Regular } from './UiMenuDots3HCircleIcon20Regular';
import { UiMenuDots3HCircleIcon20Solid } from './UiMenuDots3HCircleIcon20Solid';
import { UiMenuDots3HCircleIcon24Regular } from './UiMenuDots3HCircleIcon24Regular';
import { UiMenuDots3HCircleIcon24Solid } from './UiMenuDots3HCircleIcon24Solid';
import { UiMenuDots3HCircleIcon32Regular } from './UiMenuDots3HCircleIcon32Regular';
import { UiMenuDots3HCircleIcon64Regular } from './UiMenuDots3HCircleIcon64Regular';
var sizes = {
    16: {
        light: UiMenuDots3HCircleIcon16Light,
        regular: UiMenuDots3HCircleIcon16Regular,
        solid: UiMenuDots3HCircleIcon16Solid,
    },
    20: {
        light: UiMenuDots3HCircleIcon20Light,
        regular: UiMenuDots3HCircleIcon20Regular,
        solid: UiMenuDots3HCircleIcon20Solid,
    },
    24: {
        regular: UiMenuDots3HCircleIcon24Regular,
        solid: UiMenuDots3HCircleIcon24Solid,
    },
    32: {
        regular: UiMenuDots3HCircleIcon32Regular,
    },
    64: {
        regular: UiMenuDots3HCircleIcon64Regular,
    },
};
export var UiMenuDots3HCircleIcon = forwardRef('UiMenuDots3HCircleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
